import { render } from "./LostItemDashboard.vue?vue&type=template&id=0773c090&scoped=true"
import script from "./LostItemDashboard.vue?vue&type=script&lang=js"
export * from "./LostItemDashboard.vue?vue&type=script&lang=js"

import "./LostItemDashboard.vue?vue&type=style&index=0&id=0773c090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0773c090"]])

export default __exports__